import { AxiosPostBody } from '../../../types/AxiosPost';
import { UserCredentialsType } from '../../../types/types';
import axiosPost from '../axiosPost';

export const ProvinciaGet = async (arg: UserCredentialsType) => {
    const body: AxiosPostBody = {
        "service": "ProvinciaGet",
        "params": { }
    };

    try {
        const result = await axiosPost('Y', body, arg)
       
        return result
    } catch (err) {
        console.log(err)
    }
};